"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function SvgSideI(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    height: "100%"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "path-1",
    d: "M0 0h83.32v22.396H0z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Auto/compacto/LateralI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "matrix(-1 0 0 1 84 13)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M82.562 18.742c.385-.196.268-.136.542-.28a.382.382 0 00.205-.34c0-.74.038-.955-.024-1.442-.068-.512-.211-.832-.68-1.03a3.511 3.511 0 00-.048-.166c-.36-.28-.702-.945-1.343-2.048-.06-.104-.074-.307.007-.403C77.578 9.435 68.553 8.34 63.52 7.847l-1.541.12C56.27 4.884 51.835 2.836 48.08 1.641 44.89.624 42.092.17 39.155.082c-7.71-.258-13.109.065-18.113 1.434l-.011.002c-3.465.948-6.772 2.414-10.495 4.517l-6.16.936c-.498.04-1.347.394-1.666 1.033-.416.846-.124.015-1.761 5.403-.195.063-.353.131-.48.207a.95.95 0 00-.462.94l.216 1.763.375.26 1.494 2.48-.106.189.304.505c.092.153.23.272.39.344.147.034.293.057.43.072 9.005.764 8.25.704 8.633.723v-.473l13.19.724v.473l34.855.751v-.473l13.281.03v.474l9.893-.715c.315-.08.285-.485.076-.589-.17-.085-.393-.128-.555-.204-.128-.059-.219-.136-.219-.269l.142-1.621c0-.108.062-.204.156-.256",
    id: "Fill-1",
    fill: "#DFDFDC",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M59 31.356v.948L72 33v-1.644C72 27.742 69.198 25 65.5 25c-3.697 0-6.5 2.742-6.5 6.356",
    id: "Fill-4",
    fill: "#000",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 25c3.955 0 7 3.208 7 7.015V34l-14-.03v-2.507C11 27.656 14.045 25 18 25",
    id: "Fill-6",
    fill: "#000",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 32a6 6 0 1012 0 6 6 0 00-12 0",
    id: "Fill-8",
    fill: "#3E3E3E",
    transform: "matrix(-1 0 0 1 34 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.77 31.254a3.5 3.5 0 00-6.54 2.492 3.5 3.5 0 006.54-2.492",
    id: "Fill-10",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.836 31.61a2.499 2.499 0 10-4.672 1.78 2.499 2.499 0 104.672-1.78",
    id: "Fill-12",
    fill: "#4C4C4C",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.032 35.495a3.496 3.496 0 01-.057-6.99 3.496 3.496 0 01.057 6.99M16.967 28a4 4 0 10.066 8 4 4 0 00-.066-8",
    id: "Fill-14",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 34 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.133 33.994c-.216.381-.719.994-.816.53l-.081-.384a.861.861 0 01.561-.991l.37-.128c.449-.155.181.592-.034.973m-1.794-4.083l-.292.262a.861.861 0 01-1.14.01l-.295-.257c-.358-.311.422-.453.86-.457.438-.003 1.22.126.867.442m-.818 5.62c-.437.003-1.22-.126-.867-.442l.292-.262a.861.861 0 011.14-.01l.295.257c.358.311-.421.453-.86.457m-2.326-3.68l-.37.128c-.448.155-.181-.591.035-.973.215-.38.718-.994.816-.53l.08.384a.861.861 0 01-.56.991m.588 2.318l-.074.385c-.09.465-.604-.14-.825-.517-.223-.378-.502-1.12-.051-.972l.372.122c.413.134.66.555.578.982m3.425-3.338l.074-.385c.09-.465.603.139.825.517.222.377.501 1.12.051.972l-.373-.122a.861.861 0 01-.577-.982m-1.738-1.83A3.5 3.5 0 1017.53 36a3.5 3.5 0 00-.058-7",
    id: "Fill-16",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.586 31.586a2 2 0 102.828 2.828 2 2 0 00-2.828-2.828",
    id: "Fill-18",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 33c.002.26.104.501.27.68a.203.203 0 01.238.003.207.207 0 01.076.226.99.99 0 00.84-.004.207.207 0 01.075-.228.204.204 0 01.238-.004 1.01 1.01 0 00.255-.807.205.205 0 01-.191-.143.207.207 0 01.07-.228 1 1 0 00-.682-.495.205.205 0 01-.388.002c-.292.06-.538.247-.677.502a.208.208 0 01-.118.372c-.004.04-.006.082-.006.123",
    id: "Fill-20",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-22",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 36 0)",
    d: "M17.906 30.827l-.086.178.094.173.18-.005.086-.178-.094-.173z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-24",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 34 0)",
    d: "M17.12 31.856l-.181-.034-.12.143.062.179.18.034.12-.143z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-26",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 34 0)",
    d: "M17.18 33.069l-.025-.179-.18-.068-.155.11.025.178.18.068z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-28",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 38 0)",
    d: "M18.984 33.178l.18-.077.016-.178-.164-.101-.18.077-.016.178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-30",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 38 0)",
    d: "M18.82 32.043l.127.135.18-.043.053-.178-.127-.135-.18.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 27.712c2.531 0 4.686 1.37 5.5 3.288-.42-2.267-2.722-4-5.5-4s-5.08 1.733-5.5 4c.814-1.918 2.969-3.288 5.5-3.288",
    id: "Fill-32",
    fill: "#585858",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5 37.288c-2.531 0-4.686-1.37-5.5-3.288.42 2.267 2.722 4 5.5 4s5.08-1.733 5.5-4c-.814 1.918-2.969 3.288-5.5 3.288",
    id: "Fill-34",
    fill: "#212121",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.467 28.388c1.51-.016 2.815 1.044 3.533 2.611-.6-1.766-1.944-3.016-3.53-2.999-1.549.017-2.875 1.247-3.47 3 .711-1.551 1.995-2.596 3.467-2.612",
    id: "Fill-36",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.533 35.612c-1.51.016-2.815-1.044-3.533-2.611.6 1.766 1.944 3.016 3.53 2.999 1.549-.017 2.875-1.247 3.47-3-.711 1.551-1.995 2.596-3.467 2.612",
    id: "Fill-38",
    fill: "#FAFAFA",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.593 28.6c1.652.051 3.005 1.494 3.407 3.399-.179-2.23-1.673-4.018-3.529-3.999-1.813.019-3.294 1.772-3.471 4 .442-2.104 2-3.482 3.593-3.4",
    id: "Fill-40",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.407 35.4c-1.652-.051-3.005-1.494-3.407-3.399.179 2.23 1.673 4.018 3.529 3.999 1.813-.019 3.294-1.772 3.471-4-.442 2.104-2 3.482-3.593 3.4",
    id: "Fill-42",
    fill: "#F5F5F5",
    transform: "matrix(-1 0 0 1 35 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.537 31.25c.203.222.357.477.463.75a2.284 2.284 0 00-.58-1.356c-.784-.859-2.056-.859-2.84 0-.346.379-.54.861-.58 1.356.106-.273.26-.528.463-.75.849-.93 2.225-.93 3.074 0",
    id: "Fill-44",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.463 32.75A2.397 2.397 0 0116 32c.04.495.234.977.58 1.356.784.859 2.056.859 2.84 0 .346-.379.54-.861.58-1.356-.106.273-.26.528-.463.75-.849.93-2.225.93-3.074 0",
    id: "Fill-46",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 33a1.127 1.127 0 00-.257-.45 1.044 1.044 0 00-.34-.244.987.987 0 00-.403-.085c-.281 0-.545.117-.744.329-.121.13-.207.285-.256.45.016-.25.113-.495.29-.686a.965.965 0 011.094-.233 1 1 0 01.325.233c.178.19.275.436.291.686",
    id: "Fill-48",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 32c-.05.165-.135.32-.257.45-.099.106-.215.189-.34.244a.987.987 0 01-.403.085c-.281 0-.545-.117-.744-.329A1.137 1.137 0 0117 32c.016.25.113.495.29.686a.965.965 0 001.094.233 1 1 0 00.325-.233c.178-.19.275-.436.291-.686",
    id: "Fill-50",
    fill: "#4C4C4C",
    transform: "matrix(-1 0 0 1 36 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59 32a6 6 0 1012 0 6 6 0 00-12 0",
    id: "Fill-52",
    fill: "#3E3E3E",
    transform: "matrix(-1 0 0 1 130 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.77 31.254a3.5 3.5 0 00-6.54 2.492 3.5 3.5 0 006.54-2.492",
    id: "Fill-54",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.836 31.61a2.499 2.499 0 10-4.672 1.78 2.499 2.499 0 104.672-1.78",
    id: "Fill-56",
    fill: "#4C4C4C",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.032 35.495a3.496 3.496 0 01-.057-6.99 3.496 3.496 0 01.057 6.99M64.967 28a4 4 0 10.066 8 4 4 0 00-.066-8",
    id: "Fill-58",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 130 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.133 33.994c-.216.381-.719.994-.816.53l-.081-.384a.861.861 0 01.561-.991l.37-.128c.449-.155.181.592-.034.973m-1.794-4.083l-.292.262a.86.86 0 01-1.14.01l-.295-.258c-.358-.31.422-.452.86-.456.438-.003 1.22.126.867.442m-.818 5.62c-.437.003-1.22-.126-.867-.442l.292-.262a.861.861 0 011.14-.01l.295.257c.358.311-.421.453-.86.457m-2.326-3.68l-.37.128c-.448.155-.181-.591.035-.973.215-.38.718-.994.816-.53l.08.384a.861.861 0 01-.56.991m.588 2.318l-.074.385c-.09.465-.604-.14-.825-.517-.223-.378-.502-1.12-.051-.972l.372.122c.413.134.66.555.578.982m3.425-3.338l.074-.385c.09-.465.603.139.825.517.222.377.501 1.12.051.972l-.373-.122a.861.861 0 01-.577-.982m-1.738-1.83a3.5 3.5 0 10.058 7 3.5 3.5 0 00-.058-7",
    id: "Fill-60",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.586 31.586a2 2 0 102.828 2.828 2 2 0 00-2.828-2.828",
    id: "Fill-62",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65 33c.002.26.104.501.27.68a.203.203 0 01.238.003.207.207 0 01.076.226.99.99 0 00.84-.004.207.207 0 01.075-.228.204.204 0 01.238-.004 1.01 1.01 0 00.255-.807.205.205 0 01-.191-.143.208.208 0 01.07-.228 1 1 0 00-.682-.495.206.206 0 01-.194.14.204.204 0 01-.194-.138c-.292.06-.538.247-.677.502a.208.208 0 01-.118.372 1.02 1.02 0 00-.006.123",
    id: "Fill-64",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-66",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 132 0)",
    d: "M65.906 30.827l-.086.178.094.173.18-.005.086-.178-.094-.173z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-68",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 130 0)",
    d: "M65.12 31.856l-.181-.034-.12.143.062.179.18.034.12-.144z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-70",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 130 0)",
    d: "M65.18 33.069l-.025-.179-.18-.068-.155.11.025.178.18.068z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-72",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 134 0)",
    d: "M66.984 33.178l.18-.077.016-.178-.164-.101-.18.077-.016.178z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-74",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 134 0)",
    d: "M66.82 32.043l.127.135.18-.043.053-.178-.127-.135-.18.043z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 27.712c2.531 0 4.686 1.37 5.5 3.288-.42-2.267-2.722-4-5.5-4s-5.08 1.733-5.5 4c.814-1.918 2.969-3.288 5.5-3.288",
    id: "Fill-76",
    fill: "#585858",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.5 37.288c-2.531 0-4.686-1.37-5.5-3.288.42 2.267 2.722 4 5.5 4s5.08-1.733 5.5-4c-.814 1.918-2.969 3.288-5.5 3.288",
    id: "Fill-78",
    fill: "#212121",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.467 28.388c1.51-.016 2.815 1.044 3.533 2.611-.6-1.766-1.944-3.016-3.53-2.999-1.549.017-2.875 1.247-3.47 3 .711-1.551 1.995-2.596 3.467-2.612",
    id: "Fill-80",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.533 35.612c-1.51.016-2.815-1.044-3.533-2.611.6 1.766 1.944 3.016 3.53 2.999 1.549-.017 2.875-1.247 3.47-3-.711 1.551-1.995 2.596-3.467 2.612",
    id: "Fill-82",
    fill: "#FAFAFA",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.593 28.6c1.652.051 3.005 1.494 3.407 3.399-.179-2.23-1.673-4.018-3.529-3.999-1.813.019-3.294 1.772-3.471 4 .442-2.104 2-3.482 3.593-3.4",
    id: "Fill-84",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.407 35.4c-1.652-.051-3.005-1.494-3.407-3.399.179 2.23 1.673 4.018 3.529 3.999 1.813-.019 3.294-1.772 3.471-4-.442 2.104-2 3.482-3.593 3.4",
    id: "Fill-86",
    fill: "#F5F5F5",
    transform: "matrix(-1 0 0 1 131 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.537 31.25c.203.222.357.477.463.75a2.283 2.283 0 00-.58-1.356c-.784-.859-2.056-.859-2.84 0-.346.379-.54.861-.58 1.356.106-.273.26-.528.463-.75.849-.93 2.225-.93 3.074 0",
    id: "Fill-88",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.463 32.75A2.396 2.396 0 0164 32c.04.495.234.977.58 1.356.784.859 2.056.859 2.84 0 .346-.379.54-.861.58-1.356-.106.273-.26.528-.463.75-.849.93-2.225.93-3.074 0",
    id: "Fill-90",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 33a1.13 1.13 0 00-.257-.45 1.045 1.045 0 00-.34-.244.987.987 0 00-.403-.085c-.281 0-.545.117-.744.329-.121.13-.207.285-.256.45.016-.25.113-.495.29-.686a.965.965 0 011.094-.233 1 1 0 01.325.233c.178.19.275.436.291.686",
    id: "Fill-92",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67 32c-.05.165-.135.32-.257.45-.099.106-.215.189-.34.244a.987.987 0 01-.403.085c-.281 0-.545-.117-.744-.329A1.137 1.137 0 0165 32c.016.25.113.495.29.686a.965.965 0 001.094.233c.12-.053.23-.131.325-.233.178-.19.275-.436.291-.686",
    id: "Fill-94",
    fill: "#4C4C4C",
    transform: "matrix(-1 0 0 1 132 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79 29l1.66 3h1.88c.202 0 .356-.07.422-.19.064-.12.047-.296-.048-.487a8.947 8.947 0 00-.432-.763 2.693 2.693 0 00-1.73-1.214L79 29z",
    id: "Fill-96",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 162 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.902 31.142a7.747 7.747 0 00-.383-.663 2.517 2.517 0 00-1.61-1.109L80 29l.36.266 1.516.292a2.33 2.33 0 011.496 1.03c.138.214.26.425.374.646.067.132.113.308.03.43-.063.091-.19.144-.354.144h-1.626l-.102.192h1.728c.22 0 .385-.075.482-.198.123-.159.133-.397-.002-.66",
    id: "Fill-98",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.167 30H81v1h2c.004-.511-.43-1.023-.833-1",
    id: "Fill-100",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 30v1h1.167c.394 0 .829-.5.833-1h-2",
    id: "Fill-102",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.875 31.667c-.126.207-.34.333-.626.333H79l.133-.323h2.116a.783.783 0 00.1-.006l.02-.004a.69.69 0 00.506-.328.865.865 0 00.114-.339c.033.262-.009.493-.114.667",
    id: "Fill-104",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 161 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 33.541c0 .277.377.358.748.459L3 31l-.13.06-.45.197c-.133.061-.22.18-.22.311L2 33.541z",
    id: "Fill-106",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 33.953L6.255 34c.287.005.537-.158.593-.387.115-.472.17-.846.147-1.317-.008-.165-.177-.296-.38-.296H4.57c-.294.117-.54.31-.694.557L3 33.953z",
    id: "Fill-108",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 10 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.215 32.062h.65c.09 0 .135-.062.135-.124H2c.008.06.13.124.215.124",
    id: "Fill-110",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.866 31.938h-.65c-.09 0-.216.056-.216.117l.002.007H3c0-.062-.045-.124-.134-.124",
    id: "Fill-112",
    fill: "#666",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.866 32.938h-.65c-.09 0-.216.056-.216.117l.002.007H3c0-.062-.045-.124-.134-.124",
    id: "Fill-114",
    fill: "#666",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.215 33.062h.65c.09 0 .135-.062.135-.124H2c.008.06.13.124.215.124",
    id: "Fill-116",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.866 32.938h-.65c-.09 0-.216.056-.216.117l.002.007H3c0-.062-.045-.124-.134-.124",
    id: "Fill-118",
    fill: "#666",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.215 33.062h.65c.09 0 .135-.062.135-.124H2c.008.06.13.124.215.124",
    id: "Fill-120",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.972 31H4.09c-.213 0-.42.059-.604.168h1.804c.179 0 .327.169.335.381.024.777-.06 1.233-.13 1.694-.049.289-.267.503-.523.497l-2.87-.06-.101.234L5.237 34c.296.007.553-.242.61-.58A9.566 9.566 0 005.972 31",
    id: "Fill-122",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 8 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 33l-.024.2c-.06.466-.324.81-.63.8L3 33.882l.104-.324 2.178.06 1.114.04c.274.009.514-.265.604-.658",
    id: "Fill-124",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 10 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 31.938c.015.04.028.081.036.124h1.465l.496-.049c.002-.024.002-.05.003-.075H2z",
    id: "Fill-126",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 31.984l-.478-.046H2c.025.039.045.08.062.124h1.935L4 31.984",
    id: "Fill-128",
    fill: "#666",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 32.984l-.472-.046H2.085a.951.951 0 01-.085.124h1.983L4 32.984",
    id: "Fill-130",
    fill: "#666",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.11 32.938c-.034.043-.07.084-.11.12l1.51.004.475-.05.015-.074H2.11z",
    id: "Fill-132",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.36 32.89c.074-.435.279-.765.505-.86.045-.02.09-.03.135-.03h-.47c-.232.103-.44.44-.514.885A1.993 1.993 0 005 33h.345l.016-.11",
    id: "Fill-134",
    fill: "#666",
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.425 32h-.41c-.07.466.109.888.425 1H6a.462.462 0 01-.155-.026c-.312-.105-.488-.518-.42-.974",
    id: "Fill-136",
    fill: "#2F302F",
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.623 32.014c-.24-.082-.496.2-.623.653.123-.164.27-.241.411-.193.285.098.442.664.351 1.266a2.134 2.134 0 01-.056.26c.124-.165.223-.418.268-.72.091-.602-.066-1.168-.35-1.266",
    id: "Fill-138",
    fill: "#0A0A0A",
    transform: "matrix(-1 0 0 1 9 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.567 32.016c-.163-.055-.332.033-.473.221a2.454 2.454 0 00-.065.298c-.104.689.077 1.337.404 1.449.163.055.332-.033.473-.221.026-.094.049-.193.064-.298.105-.689-.076-1.337-.403-1.449",
    id: "Fill-140",
    fill: "#000",
    transform: "matrix(-1 0 0 1 9 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.385 32.01a.967.967 0 00-.116-.01c-.106.07-.198.155-.269.254.435.06.7.34.595.626a.45.45 0 01-.07.12c.219-.069.39-.2.452-.364.105-.285-.16-.565-.592-.626",
    id: "Fill-142",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.89 32a1.699 1.699 0 00-.05.243 1.85 1.85 0 00.036.736l.014.007c.086.031.172.009.247-.054.014-.047.025-.097.033-.15.049-.357-.076-.707-.28-.782",
    id: "Fill-144",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 10 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.228 33.43l.016-.253.094-1.472c0-.118.048-.224.123-.279l.367-.258A.451.451 0 003 31l-.52.115c-.147.032-.278.167-.334.357a.83.83 0 00-.033.217c0 .021-.112 1.761-.112 1.783a.346.346 0 00.032.176c.126.267.664.35.828.352a.583.583 0 00-.09-.058 2.23 2.23 0 00-.127-.06c-.147-.069-.271-.107-.353-.21a.328.328 0 01-.066-.2l.003-.042z",
    id: "Fill-146",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 34c-.191-.003-.816-.13-.962-.546A.693.693 0 012 33.182L2.01 33c.001.081.015.154.039.22.063.182.218.308.387.392.09.08.204.137.313.206 0 0 .108.064.146.092.054.041.078.059.106.09",
    id: "Fill-148",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 5 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 25.984c2.511.145 4.533-.715 6.72-2.524.453-.375.345-.792-.243-.926-1.346-.306-2.446-.438-4.078-.534-1.21 1.257-1.852 2.253-2.399 3.984",
    id: "Fill-150",
    fill: "#891214",
    transform: "matrix(-1 0 0 1 159 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77 25h3.792c.398-.284.8-.616 1.208-1h-4.584c-.15.318-.288.647-.416 1",
    id: "Fill-152",
    fill: "#E2272C",
    transform: "matrix(-1 0 0 1 159 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76 23h4.748c.287-.25.369-.354.034-.438-1.195-.304-2.182-.448-3.77-.552 0 0-.223-.01-.28-.01A8.18 8.18 0 0076 23",
    id: "Fill-154",
    fill: "#E2272C",
    transform: "matrix(-1 0 0 1 157 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82 23.822v.356l.36-.009v-.347h-.36z",
    id: "Fill-156",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82 23.822v.356c.12-.004.24-.008.36-.014v-.342h-.36z",
    id: "Fill-158",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 162 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82 23.822v.356c.12-.006.24-.013.36-.022v-.334h-.36z",
    id: "Fill-160",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 162 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.095 23.822c-.096.112-.187.229-.275.35.12.004.24.005.36.006v-.356h-.085z",
    id: "Fill-162",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82 24v.997c.12.003.24.004.36.002V24h-.36z",
    id: "Fill-164",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82 24v1c.12-.001.24-.005.36-.011V24h-.36z",
    id: "Fill-166",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 164 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82 23.822v.356c.12-.022.24-.047.36-.073v-.283h-.36z",
    id: "Fill-168",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 160 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82 23.822v.356c.12-.053.24-.11.36-.169v-.187h-.36z",
    id: "Fill-170",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 158 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.82 23.822v.356c.12-.008.24-.019.36-.03v-.326h-.36z",
    id: "Fill-172",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 162 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.82 23.95v.1c.12-.032.24-.065.36-.1h-.36z",
    id: "Fill-174",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 158 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82 23.822v.356c.12-.033.24-.068.36-.106v-.25h-.36z",
    id: "Fill-176",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 160 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82 23.822v.356c.12-.016.24-.034.36-.053v-.303h-.36z",
    id: "Fill-178",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 160 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.82 23.822v.356c.12-.012.24-.025.36-.04v-.316h-.36z",
    id: "Fill-180",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 160 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 28l-3.292-.234a6.364 6.364 0 01-3.87-1.691l-1.634-1.51c-.339-.314-.246-.567.206-.565 2.957.013 5.32.757 7.6 2.36L12 28z",
    id: "Fill-182",
    fill: "#AFCDD7",
    transform: "matrix(-1 0 0 1 15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.935 26.822H4v.356h4a1.665 1.665 0 00-.065-.356",
    id: "Fill-184",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 12 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.88 25H7l1.45 1H11a7.295 7.295 0 00-.12-1",
    id: "Fill-186",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 18 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.871 26H5v.748c.11.088.222.171.336.252H9a6.699 6.699 0 00-.129-1",
    id: "Fill-188",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 14 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 27c.43.216.885.4 1.357.549A10.345 10.345 0 008.862 28c.1-.397.15-.68.135-1H5z",
    id: "Fill-190",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 14 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 27v.06a5.724 5.724 0 002.333.783c.007.004.014.004.02.004L7.938 28c.05-.389.067-.695.062-1H4z",
    id: "Fill-192",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 12 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7 26c.544.538.638.619.888.82A7.887 7.887 0 009.865 28c.046-.326.08-.624.102-.903.031-.388.039-.744.029-1.097H7z",
    id: "Fill-194",
    fill: "#6C8187",
    transform: "matrix(-1 0 0 1 17 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.8 24.432c-.118-.11-.085-.199.073-.195 2.693.067 4.87.769 7.005 2.254l.601.998-2.639-.187a6.04 6.04 0 01-3.672-1.606L3.8 24.432zm-.596.132l1.634 1.51a6.364 6.364 0 003.87 1.692L12 28l-.99-1.64C8.73 24.756 6.367 24.012 3.405 24c-.447 0-.539.252-.2.564z",
    id: "Fill-196",
    fill: "#839AA3",
    transform: "matrix(-1 0 0 1 15 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 23.979v.2H9.377l-.272-.167c-.175-.107-.126-.194.108-.19.572.01 1.128.031 1.67.067.066.004.117.043.117.09",
    id: "Fill-198",
    fill: "#FFA12F",
    transform: "matrix(-1 0 0 1 20 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 24v.898c0 .088-.081.134-.133.076L9 24h1z",
    id: "Fill-200",
    fill: "#D76D00",
    transform: "matrix(-1 0 0 1 19 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.082 25.463C2.074 26.893 2.444 27.638 3 28c-.367-.987-1.022-2.202-1.895-2.939-.026-.022-.053-.044-.079-.061-.043.167-.038.328.056.463",
    id: "Fill-202",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.04 26.067c.094 0 .141-.067.14-.134h-.36l.079.134h.14z",
    id: "Fill-204",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.063 25.933H2.82l.065.134h.295c0-.067-.04-.134-.117-.134",
    id: "Fill-206",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 6 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.06 27.067c.083 0 .123-.067.12-.134h-.36l.072.134h.169z",
    id: "Fill-208",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07 26.933l-.25.007.057.127h.303c-.002-.067-.039-.134-.11-.134",
    id: "Fill-210",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.035 27.067c.1 0 .148-.067.145-.134h-.36l.096.134h.119z",
    id: "Fill-212",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.055 26.933H1.82l.076.134h.284c-.002-.067-.044-.134-.125-.134",
    id: "Fill-214",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.957 27.933H1.82l.056.134h.304c.003-.067-.073-.134-.223-.134",
    id: "Fill-216",
    fill: "#E7E7E7",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.944 28.067c.096 0 .144-.067.146-.134h-.18l.034.134z",
    id: "Fill-218",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.946 27.826a1.18 1.18 0 01-.28-.13c-.462-.296-.741-.909-1.445-1.956a1.161 1.161 0 01-.195-.74c-.064.3-.01.617.173.892.703 1.047.983 1.66 1.445 1.956.105.067.224.118.356.152-.033-.116-.012-.047-.051-.172l-.003-.002",
    id: "Fill-220",
    fill: "#818181",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.207 25.828c.731 1.09 1.021 1.728 1.502 2.037.087.056.185.101.291.135-.424-.307-.79-.978-1.542-2.175-.07-.113-.086-.333.01-.436.022-.12-.329-.418-.453-.387-.005.019-.007.037-.011.056-.02.263.044.532.203.77",
    id: "Fill-222",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 4 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 23.91c.592.326 2.239.366 3 .059-.42-.093-1.006-.147-1.656-.147-.503 0-.964.03-1.344.088",
    id: "Fill-224",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 83 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 25.09c.374.06.835.088 1.345.088.654 0 1.244-.055 1.655-.146-.742-.302-2.396-.276-3 .059",
    id: "Fill-226",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 83 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.431 24.144c-.474.553-1.507.704-2.207.236a1.339 1.339 0 01-.39-.38c-.53.242-.83.616-.834 1h4c-.001-.328-.218-.636-.569-.856",
    id: "Fill-228",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 84 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40 25c-.004.358.247.724.807 1 .525-.874 2.01-.943 2.657-.154.33-.221.536-.514.536-.843C44 25 40 25 40 25",
    id: "Fill-230",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 84 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 23.91c.592.326 2.239.366 3 .059-.42-.093-1.006-.147-1.656-.147-.503 0-.964.03-1.344.088",
    id: "Fill-232",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 115 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 25.09c.374.06.835.088 1.345.088.654 0 1.244-.055 1.655-.146-.742-.302-2.396-.276-3 .059",
    id: "Fill-234",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 115 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.431 24.144c-.474.553-1.507.704-2.207.236a1.339 1.339 0 01-.39-.38c-.53.242-.83.616-.834 1h4c-.001-.328-.218-.636-.569-.856",
    id: "Fill-236",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 114 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55 24c-.004.358.247.724.807 1 .525-.874 2.01-.943 2.657-.154.33-.221.536-.514.536-.843C59 24 55 24 55 24",
    id: "Fill-238",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 114 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.562 15c3.66 1.113 7.854 2.959 13.438 5.843-4.318.822-3.37-1.67-14.582-5.403a29.106 29.106 0 00-.418-.138L24.562 15z",
    id: "Fill-240",
    fill: "#AFCDD7",
    transform: "matrix(-1 0 0 1 61 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 18.804l.83.128a5.696 5.696 0 003.004-.342L74 15.26 72.642 15c-3.523.8-6.854 2.025-10.642 3.804",
    id: "Fill-242",
    fill: "#AFCDD7",
    transform: "matrix(-1 0 0 1 136 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.549 18.637c2.159-1.85 4.47-2.797 8.24-3.372 2.468-.204 4.836-.323 7.303-.237a33.96 33.96 0 017.503 1.114 34.405 34.405 0 017.045 2.727c.476.247.93.49 1.36.73V22l-31.905-1.665a1.527 1.527 0 01.454-1.698",
    id: "Fill-244",
    fill: "#AFCDD7",
    transform: "matrix(-1 0 0 1 94 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33 19.782V22l-2-.129.96-2.67c.06-.167.226-.246.367-.175.141.072.208.266.148.433l-.395 1.096.61.107.31-.88z",
    id: "Fill-246",
    fill: "#354C53",
    transform: "matrix(-1 0 0 1 64 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.979 17.988a33 33 0 00-6.94-2.811 32.08 32.08 0 00-7.393-1.148c-2.43-.088-4.763.034-7.194.244-2.774.443-4.746 1.1-6.452 2.197L60 18l-.021-.012",
    id: "Fill-248",
    fill: "#CCE2E9",
    transform: "matrix(-1 0 0 1 92 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.976 18.368c-.068.563-.272 1.026-.519 1.262a.686.686 0 01-.177.127l.084.243-1.186-.067-.037-.245a.6.6 0 01.066-.382l-.01-.02a1.63 1.63 0 01-.197-.65c.087-.18.207-.347.358-.488.456-.427.919-.807 1.403-1.148.062.095.113.21.152.343.084.28.112.633.063 1.025",
    id: "Fill-250",
    fill: "#354C53",
    transform: "matrix(-1 0 0 1 124 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.929 19.375a14.775 14.775 0 013.345-1.84l.258 3.09-4.079-.18c-.072-.391.103-.8.476-1.07m-.818 1.409L63 21l-.334-4a15.31 15.31 0 00-4.028 2.111c-.585.424-.785 1.09-.527 1.673",
    id: "Fill-252",
    fill: "#2B3D44",
    transform: "matrix(-1 0 0 1 121 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.089 19.727l.283 2.104 1.542.169-.63-1.776c.322-.153.609-.691.693-1.38.096-.787-.116-1.418-.461-1.598 0 0-.47-.243-.583-.246-.71-.02-1.256 1.887-.713 2.777l-.131-.05z",
    id: "Fill-254",
    fill: "#354C53",
    transform: "matrix(-1 0 0 1 90 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.995 18L44 17.862c.086-.955.472-1.877.923-1.862.115.004.588.3.588.3.318.2.524.858.484 1.7",
    id: "Fill-256",
    fill: "#617E8C",
    transform: "matrix(-1 0 0 1 90 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.906 19.01c2.149-1.863 4.45-2.816 8.203-3.395 2.456-.205 4.812-.325 7.267-.239 2.512.089 5.025.466 7.47 1.121a34.006 34.006 0 017.01 2.747c.475.249.926.494 1.354.734v2.419L26.455 20.72a1.55 1.55 0 01.451-1.71m30.122-.073a34.065 34.065 0 00-14.639-3.91c-2.48-.087-4.85.034-7.324.241-3.8.586-6.159 1.54-8.398 3.482a1.882 1.882 0 00-.453 2.305L63 23c-.855-1.292-4.577-3.329-5.972-4.062",
    id: "Fill-258",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 89 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61 17l-.41-.02-.033-.436a13.43 13.43 0 00-.84.394L59 16.904A14.18 14.18 0 0160.924 16L61 17z",
    id: "Fill-260",
    fill: "#617E8C",
    transform: "matrix(-1 0 0 1 120 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44 15l.763 6.85L48 22l-2.226-6.95c-.215-.012-.428-.02-.643-.026-.376-.012-.752-.02-1.131-.024",
    id: "Fill-262",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 92 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58 17.163l.387 3.814L59 21l-.407-4c-.2.052-.398.106-.593.163",
    id: "Fill-264",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 117 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 18.804l.83.127a5.63 5.63 0 003.005-.342L74 15.26 72.642 15c-.132.029-.262.06-.392.093.432.078.296.052.861.16.106.02.123.14.026.18l-7.387 3.015a5.444 5.444 0 01-2.884.327l-.604-.093-.262.122",
    id: "Fill-266",
    fill: "#2B3D44",
    transform: "matrix(-1 0 0 1 136 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 15.302c.14.046.28.091.418.138C33.18 18.691 33.724 21 36.55 21c.42 0 .89-.05 1.449-.157l-.263-.136c-.345.054-.854.13-1.186.118-1.226-.05-1.997-.449-3.398-1.262-1.651-.96-4.114-2.389-9.09-4.09a.104.104 0 01.015-.202l.817-.168-.333-.103-1.562.302z",
    id: "Fill-268",
    fill: "#2B3D44",
    transform: "matrix(-1 0 0 1 61 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.643 33.66L25.374 33c-.202-.004-.37.141-.374.325L59 34c.005-.183-.155-.336-.357-.34",
    id: "Fill-270",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 84 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 34c-.005.183.155.336.357.34l33.269.66c.202.004.37-.141.374-.325L25 34z",
    id: "Fill-272",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 84 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 33.313L2 34a.152.152 0 010-.032.401.401 0 01.378-.358L11.48 33c.126.04.262.076.375.13a.28.28 0 01.146.183",
    id: "Fill-274",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 14 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.768 34.355l-9.052.598L2 35 2 34.66l9.988-.66c.04.14-.019.308-.22.355",
    id: "Fill-276",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 14 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81 34l-8.27-.624a3.846 3.846 0 01-.34-.054.81.81 0 01-.372-.294L72 33l8.997.679L81 34z",
    id: "Fill-278",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 153 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82 33l-9.755-.668L72 32l9.612.658c.218.015.386.163.388.342",
    id: "Fill-280",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 154 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.245 21.188a1.29 1.29 0 00-.273.289c-.467.708-.14.013-1.972 4.523l.066-.002.302-.532c.576-1.458 1.247-2.289 2.266-3.181.087-.076.366-.314.366-.314v-.553c0-.447-.347-.555-.755-.23",
    id: "Fill-282",
    fill: "#CDCDCA",
    transform: "matrix(-1 0 0 1 163 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56 33a6.085 6.085 0 01-.423-.39c-.116-.117-.221-.233-.362-.382a458.91 458.91 0 01-9.153-.403c-4.261-.248-13.069-.61-18.114-.825L26 32.236c5.047.11 15.024.365 20.07.475 2.534.055 7.396.234 9.93.289",
    id: "Fill-284",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 82 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.936 28.454c.078.285.177.602-.328.538-1.412-.18-2.475-.32-3.31-.611a6.325 6.325 0 01-2.135-1.227 10.226 10.226 0 01-.59-.555c-.19-.193-.378-.393-.573-.599a5.45 5.45 0 003.125 1.28c.938.072 1.875.146 2.812.22.132.167.292.29.48.35a.974.974 0 01.407.353c.024.037.092.175.112.25",
    id: "Fill-286",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 11 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.436 25.78h-.002a11.373 11.373 0 00-1.788-.396c-.61-.085-.785.21-.387.655.209.233.422.533.692 1.025a6.949 6.949 0 01.42.917c.116.427.31 1.237.158 1.652-1.096-2.745-3.808-4.724-7.096-4.724-3.62 0-6.54 2.03-7.377 5.091-.197-.221-.33-1.314.417-2.773a6.27 6.27 0 011.051-1.441c.346-.356.967-.932-.397-.976l-37.12-1.119c-.73-.022-.823.262-.2.621a7.475 7.475 0 011.605 1.25c.633.64 1.08 1.41 1.388 2.23.111.403.363 1.445.098 1.783-.979-2.907-3.792-4.908-7.276-4.908-3.554 0-6.412 2.083-7.335 5.087-.097-.197-.148-.676-.054-1.203.243-1.393 1.106-2.65 2.258-3.586.194-.159.405-.312.632-.457.913-.585.764-1.092-.338-1.14-2.16-.095-4.582-.097-6.873.619.423-.282.847-.602 1.277-.96.44-.366.335-.774-.235-.904-1.305-.298-2.372-.428-3.954-.522 1.401-.552 7.174-.676 9.675-.563l56.54 2.379c2.146.08 3.95.532 5.785 1.109-.101-.016-.356-.059-.811-.107a17.267 17.267 0 00-1.7-.087c-.122 0-.306.02-.372.116-.086.122.058.284.175.381l1.144.951",
    id: "Fill-288",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 88 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.04 26.849c-.16.565.178 1.162.646 1.15l5.067-.116c.059 0 .115-.002.172-.007.857-.077 1.635-.69 2.075-1.65L76.88 26c-.184.078-.333.16-.452.252a1.11 1.11 0 00-.385.587l-.002.01",
    id: "Fill-290",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 160 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.59 14.005c-4.225.06-8.6.733-11.59 1.777l.075.022c6.184-2.16 17.262-2.596 23.846.196l.079-.021c-3.138-1.33-7.608-2.043-12.41-1.974",
    id: "Fill-292",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 100 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.97 26l.03-.023-.878-.487-6.326-.19c-.852-.022-.997-.228-1.236-.57l-.52-.73-.04.017c.05.072.477.668.526.737.238.34.396.564 1.27.588l6.309.173.865.485z",
    id: "Fill-294",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 149 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.058 22.003L45 22c1.21 3.988 1.115 7.348.509 11.995l.054.005c.607-4.649.703-8.009-.505-11.997",
    id: "Fill-296",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 91 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.044 21c.506-.58.943-.962 2.405-1.082 4.318-.423 5.044-.445 6.551-.913L79.905 19c-1.536.477-2.287.473-6.46.882-1.482.12-1.931.528-2.445 1.116l.044.002z",
    id: "Fill-298",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 151 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.907 24.98L24 25c-1.933-1.487-4.831-1.95-8.154-2.446-2.313-.345-4.847-.733-7.6-1.542L8 21c2.755.81 5.526 1.256 7.84 1.601 3.317.496 6.132.946 8.067 2.38",
    id: "Fill-300",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 32 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.037 27l1.08-.363 2.862.025c.292 0 .575-.131.798-.37l.223-.258-.04-.034-.213.25a1.056 1.056 0 01-.768.356l-2.877-.01L9 26.956l.037.045z",
    id: "Fill-302",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 23 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63 32.956l-1.778-.053c.966-4.907.989-8.83.104-10.766a1.292 1.292 0 00-.1-.176h-.054c.046.068.084.132.112.193.882 1.93.858 5.846-.108 10.748l-29.856-.875c-.587-.016-1.064-.435-1.135-.997a12.135 12.135 0 00-1.058-3.625c-.623-1.315-1.433-2.38-2.405-3.165a3.694 3.694 0 01-.903-1.073L24.042 20l-.042.022 1.777 3.166c.238.424.545.79.914 1.087 1.806 1.458 3.095 3.985 3.447 6.76.074.585.57 1.021 1.18 1.038l31.68.927.002-.044z",
    id: "Fill-304",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 87 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70 25.993l1.958.057.042-.038-1.972-.062-.028.043",
    id: "Fill-306",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 142 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-308",
    fill: "#4C4C4C",
    transform: "matrix(-1 0 0 1 94 0)",
    d: "M46.068 15h-.042l-.026.003 1.93 6.994L48 22z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 26.959l.026.066.974.016-.015-.076-.985-.006z",
    id: "Fill-310",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 23 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5 22.053c-.386 0-.75.15-1.023.424a1.437 1.437 0 00-.424 1.023 1.448 1.448 0 002.894 0c0-.386-.15-.75-.424-1.023a1.437 1.437 0 00-1.023-.424m0 2.947a1.503 1.503 0 01-1.061-2.561 1.503 1.503 0 012.122 0A1.503 1.503 0 0173.5 25",
    id: "Fill-312",
    fill: "#9A9A9A",
    transform: "matrix(-1 0 0 1 147 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.288 23.337c-.164.186-.26.42-.288.663l.037-.004c.029-.237.124-.457.276-.63a.917.917 0 01.692-.325c.261 0 .507.115.692.325.137.156.228.35.266.562H74a1.203 1.203 0 00-.277-.59.932.932 0 00-1.435 0",
    id: "Fill-314",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 146 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.18 24a25.187 25.187 0 00-.323-1.998L44.82 22c.137.68.244 1.342.323 1.999l.037.001z",
    id: "Fill-316",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 90 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.82 23c.15.54.26 1.212.328 1.999l.032.001c-.067-.784-.175-1.456-.325-1.998L25.82 23z",
    id: "Fill-318",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 52 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.08 21.003L61 21l1.924 3 .076-.002-1.92-2.995z",
    id: "Fill-320",
    fill: "#CDCDCD",
    transform: "matrix(-1 0 0 1 124 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.96 22.854c-.41.092-.669.22-1.176.093-.06-.014-.114-.063-.152-.132L29 21.447c.317-.023.65-.08 1.007-.164a.582.582 0 00.349-.283l.638 1.755c.016.04-.001.09-.033.099",
    id: "Fill-322",
    fill: "#B4B4B4",
    transform: "matrix(-1 0 0 1 60 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31 22.005l.58.877a.225.225 0 00.14.085c.103.019.196.03.28.033l-.412-.735c-.063-.112-.304-.277-.51-.264a4.451 4.451 0 01-.078.004",
    id: "Fill-324",
    fill: "#131313",
    transform: "matrix(-1 0 0 1 63 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.986 21.254c.076.297-.175.586-.546.634-1.142.147-2.075.175-3.012-.077-.303-.081-.479-.336-.415-.589.127-.504.49-.854 1.217-1.116.33-.12.704-.14 1.05-.054.603.15.97.374 1.429.78a.86.86 0 01.277.422",
    id: "Fill-326",
    fill: "#DFDFDC",
    transform: "matrix(-1 0 0 1 62 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.497 20.809c-.317.162-.411.226-.468.173-.031-.029-.033-.085-.025-.121.099-.502 1.2-.929 2.08-.852.753.05 1.017.46.882.577-.035.03-.094.012-.14-.009-.557-.301-1.733-.033-2.33.232",
    id: "Fill-328",
    fill: "#F2F2F2",
    transform: "matrix(-1 0 0 1 63 0)"
  })));
}
var _default = exports["default"] = SvgSideI;